module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/long-brown-hair-red/long-brown-hair-red@2x.png"